import React from 'react';
import { Box, Text, Button, PlusIcon, BoxProps } from '@razorpay/blade/components';
import { getStaticMediaUrl } from 'utils/Urls';
import noBankAccountFoundImg from 'assets/employeeOnboarding/noBankAccount.png';
import { useHistory } from 'react-router-dom';
import { routePaths } from 'components/Routes/data';
import { useUserId } from '../hooks/useUserId';

export const NoBankAccountCard = (boxProps: BoxProps = {}) => {
  const userId = useUserId();
  const history = useHistory();
  const onAddAccount = () => {
    history.push({
      pathname: routePaths.employeeDetailsV2.bankAccountDetails.add,
      search: `?userId=${userId}`,
    });
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding="spacing.6"
      borderRadius="medium"
      borderWidth="thinner"
      borderColor="surface.border.gray.muted"
      height="70vh"
      backgroundColor="surface.background.gray.intense"
      {...boxProps}>
      <img
        width="150px"
        height="150px"
        src={getStaticMediaUrl(noBankAccountFoundImg)}
        alt="No Active Bank Account Found"
      />
      <Text size="medium" color="surface.text.gray.muted" marginY="spacing.4">
        No Active Bank Account Found
      </Text>
      <Button
        onClick={onAddAccount}
        variant="primary"
        icon={PlusIcon}
        iconPosition="left"
        size="small">
        Add Bank Account
      </Button>
    </Box>
  );
};
